export default [
    {
        path: '',
        name: 'serviceRouter',
        component: () => import('./page-service')
    }
]